import React, { useEffect, useState } from 'react'
import Blocks from './Blocks'
import Default from './Default'

const CountdownTimer = ({ startDate, endDate, style, text }) => {
  const [timeLeft, setTimeLeft] = useState(null)
  const blockStyles = style?.toLowerCase() === 'blocks'

  useEffect(() => {
    const endUTC = new Date(endDate).toUTCString()

    const calculateTimeLeft = () => {
      const now = new Date()

      if (now < new Date(startDate)) {
        return null
      }

      const difference = new Date(endUTC) - now // Using UTC for consistency

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24))
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24)
        const minutes = Math.floor((difference / 1000 / 60) % 60)
        return { days, hours, minutes }
      }

      return { days: 0, hours: 0, minutes: 0 }
    }

    setTimeLeft(calculateTimeLeft())

    const intervalId = setInterval(() => {
      setTimeLeft(calculateTimeLeft())
    }, 60000)

    return () => clearInterval(intervalId)
  }, [startDate, endDate])

  if (!timeLeft) {
    return null
  }

  return blockStyles ? (
    <Blocks className="countdown-timer" timeLeft={timeLeft} text={text} />
  ) : (
    <Default className="countdown-timer" timeLeft={timeLeft} />
  )
}

export default CountdownTimer
